import { createDomain, sample } from 'effector'
import { createGate } from 'effector-react'
import { interval } from 'patronum'
import { Debt, ReportData } from '~/shared/api'
import { isDevEnv } from '~/shared/config/env'
import { logger } from '~/shared/lib/logger'
import { snackbarEnqueued } from '~/shared/lib/notifications'

export const Gate = createGate()

const domain = createDomain('entities.debt')

const fetchReport = async () => {
  return await Debt.report()
}

export const getReportFx = domain.createEffect({
  handler: fetchReport,
})

export const getReportSilentFx = domain.createEffect({
  handler: fetchReport,
})

export const clearReport = domain.createEvent()

export const $report = domain
  .createStore<ReportData | null>(null)
  .on([getReportFx.doneData, getReportSilentFx.doneData], (_, report) => report)
  .on(clearReport, () => null)

sample({
  clock: Gate.open,
  source: $report,
  filter: (report) => !report,
  target: getReportFx,
})

sample({
  clock: getReportFx.failData,
  fn(e) {
    logger.error(e)
    return {
      message: 'Ошибка получения данных по текущему долгу',
      variant: 'danger' as const,
    }
  },
  target: snackbarEnqueued,
})

const intervalRequestStarted = domain.createEvent()
const intervalRequestStopped = domain.createEvent()

if (!isDevEnv) {
  const { tick } = interval({
    timeout: 60000,
    start: intervalRequestStarted,
    stop: intervalRequestStopped,
    leading: false,
    trailing: false,
  })

  sample({
    clock: tick,
    target: getReportSilentFx,
  })

  sample({
    clock: Gate.open,
    target: intervalRequestStarted,
  })
  sample({
    clock: Gate.close,
    target: intervalRequestStopped,
  })
}
